import type { PortableTextTypeComponentProps } from '@portabletext/react'
import type { FC } from 'react'

import type { CMSComponentResponsiveImage } from '@/types/sanity'
import { ResponsiveImage as Image } from '@components/Shared/ResponsiveImage'
// import './responsive-image.scss'

export const ResponsiveImage: FC<
  PortableTextTypeComponentProps<CMSComponentResponsiveImage>
> = (props) => {
  return (
    <Image
      document={props.value}
      overrides={{
        mobileAspectRatio: '1/1',
        desktopAspectRatio: '1/1',
      }}
    />
  )
}
